export default __webpack_public_path__ + "static/realization-3-11ccf938d7aa0469fda7228b4db37fcf.jpg";